var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_41745)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.584 23.8809C10.1675 23.8809 6.97701 22.3626 4.83164 19.713L7.02643 17.9363C8.6337 19.9192 11.0248 21.0562 13.584 21.0562C18.2575 21.0562 22.0581 17.2555 22.0581 12.582C22.0581 7.90856 18.2575 4.10792 13.584 4.10792C11.0248 4.10792 8.63368 5.24486 7.02644 7.22781L4.83165 5.45107C6.97701 2.80149 10.1675 1.28321 13.584 1.28321C19.8139 1.28321 24.8828 6.35215 24.8828 12.582C24.8828 18.8119 19.8139 23.8809 13.584 23.8809ZM12.464 18.5238L10.4669 16.5267L12.9993 13.9944L0.872813 13.9944L0.872813 11.1697L12.9993 11.1697L10.4669 8.63733L12.464 6.64027L18.4058 12.582L12.464 18.5238Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_41745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.01,
    height: 24.01,
    fill: "white",
    transform: "translate(24.8828 24.582) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartArrow);
export default __webpack_public_path__ + "static/media/startArrow.e8db72809734381888821ccfeddb828f.svg";
export { ForwardRef as ReactComponent };